import { isoToDate } from "../../helpers/helpers"

export const ContractDetailList = ({ contract }) => {
    return (
        <tr className="text-center">
            <td className="custom-border">
                <p className="m-0">{contract?.contract_code}</p>
            </td>
            <td className="custom-border">
                <p className="m-0">{contract?.contract_description}</p>
            </td>
            <td className="custom-border">
                <p className="m-0">{contract?.opening ? contract.opening?.opening_description : '-'}</p>
            </td>
            <td className="custom-border">
                <p className="m-0">{contract?.contract_assign_date_in ? isoToDate(contract?.contract_assign_date_in) : '-'}</p>
            </td>
            <td>
                <p className="m-0">{contract?.contract_assign_date_out ? isoToDate(contract?.contract_assign_date_out) : '-'}</p>
            </td>
        </tr>
    )
}
